import * as React from "react";
import {useState} from "react";

import './HRFormBlock.pcss';

interface Props {
  children:any;
  description?:string;
  help?:any;
  show?:boolean;
  title:string;
}

export const HRFormBlock = (props:Props) => {

  const [showHelp, setShowHelp] = useState(false);

  if(undefined!==props.show && props.show===false) {
    return null;
  }


  function toggleHelp() {
    setShowHelp(!showHelp);
  }

  return (
    <div className={'hr-form-block'}>
      <h3>{props.title}</h3>
      {props.description && <h4>{props.description}</h4>}
      {props.help && !showHelp && <div className="help-toggle" onClick={toggleHelp}>show help</div> }
      {showHelp &&
        <div className={"help"}>
          {props.help}
          <div className="help-toggle" onClick={toggleHelp}>hide help</div>
        </div>
      }

      <div className={"block-body"}>
        {props.children}
      </div>
    </div>
  );
}